const CONFIG = {
  REACT_APP_NODE_ENV: process.env.REACT_APP_NODE_ENV,
  REACT_APP_API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  REACT_APP_API_BROADCASTING_BASE_URL:
    process.env.REACT_APP_API_BROADCASTING_BASE_URL,
  REACT_APP_API_WS_BASE_URL: process.env.REACT_APP_API_WS_BASE_URL,
  REACT_APP_API_WS_BASE_PORT: process.env.REACT_APP_API_WS_BASE_PORT,
  REACT_APP_API_PUSHER_APP_ID: process.env.REACT_APP_API_PUSHER_APP_ID,
  REACT_APP_API_PUSHER_APP_KEY: process.env.REACT_APP_API_PUSHER_APP_KEY,
  PUBLIC_URL: process.env.PUBLIC_URL,
  PROJECT_NAME: 'Split Test Mini Apps',
  PAGINATION_LIMIT: 10,
  IS_DEV: process.env.NODE_ENV === 'development',
  TG_ID: process.env.REACT_APP_API_TG_ID,
  TG_ROW_DATA: process.env.REACT_APP_API_TG_ROW_DATA,
  MAX_ROW_DATA:
    process.env.REACT_APP_API_MAX_ROW_DATA ||
    process.env.REACT_APP_API_TG_ROW_DATA,
  YANDEX_KEY: process.env.REACT_APP_API_YANDEX_KEY,
  POLL_PROCESS: 'CURRENT_POLL_PROCESS',
  PROMO_COOKIE_NAME: 'promocode_cookie',
  ENV_MOCK: process.env.REACT_APP_TMA_MOCK === 'true',
};

export default CONFIG;
